<template>
  <div>
    <div class="panel-heading" style="display:flex; justify-content:space-between; align-items:center;">
      <h4 class="panel-title">{{ $t('reports.ordersReportTitle') }}</h4>
      <img src="../../../assets/images/black_shipzone.png" class="print-only" style="height:40px;" alt="Lasshopping" />
    </div>
    <div class="panel-body" style="display: block">
      <div class="row mb-3 no-print">
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-3">
          <date-picker
            style="margin-top: 4%; border-bottom-color: #919191"
            :date="startTime"
            :option="fromOption"
            class="form-control"
          />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-3">
          <date-picker
            style="margin-top: 4%; border-bottom-color: #919191"
            :date="endTime"
            :option="toOption"
            class="form-control"
          />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-4" style="display:flex; align-items:center; flex-wrap:nowrap; gap:8px;">
          <v-btn style="height: auto" @click="getData()" depressed :loading="loading">
            &nbsp; {{ $t('reports.apply') }}
          </v-btn>
          <v-btn v-if="rows.length" class="no-print" @click="printReport()" color="blue-grey" dark small style="height:auto;">
            <v-icon left small>print</v-icon> {{ $t('reports.printReport') }}
          </v-btn>
          <p v-if="rows.length" class="print-only"><strong>{{ $t('reports.periodColon') }} {{ startTime.time }} &mdash; {{ endTime.time }}</strong></p>
        </div>
      </div>

      <table v-if="rows.length" class="table table-bordered">
        <thead style="background-color:#4A8AF4; color:#fff;">
          <tr>
            <th>#</th>
            <th>{{ $t('columns.status') }}<span class="col-sub">{{ $t('reports.orderStatusStageHint') }}</span></th>
            <th>{{ $t('reports.numberOfOrders') }}<span class="col-sub"><b>N</b> {{ $t('reports.equalsCountOrdersWithStatus') }} (<b>A</b> {{ $t('reports.equalsSigmaOrderAmount') }})</span></th>
            <th v-for="country in countries" :key="country">{{ country }}<span class="col-sub">{{ $t('reports.qtyShipTotalPerCountryHint') }}</span></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row, index) in rows" :key="index">
            <td>{{ index + 1 }}</td>
            <td>
              <span :style="{ background: statusColor(row.status_type).bg, color: statusColor(row.status_type).color, padding: '2px 8px', borderRadius: '4px', fontSize: '12px', whiteSpace: 'nowrap' }">
                {{ formatStatus(row.status_type) }}
              </span>
            </td>
            <td>{{ row.order_count }} ( ${{ fmt(row.total_amount) }} )</td>
            <td v-for="country in countries" :key="country">
              <template v-if="row.by_country[country]">
                <div><strong>{{ $t('columns.qty') }}:</strong> {{ row.by_country[country].order_count }}</div>
                <div><strong>{{ $t('columns.shipping') }}:</strong> ${{ fmt(row.by_country[country].shipping) }}</div>
                <div><strong>{{ $t('columns.total') }}:</strong> ${{ fmt(row.by_country[country].total_amount) }}</div>
              </template>
              <template v-else>-</template>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr style="background-color:#e9f5b7; font-weight:bold;">
            <td></td>
            <td>{{ $t('reports.totalOrders') }} <span class="col-sub" style="opacity:1;">&Sigma;N, &Sigma;A</span></td>
            <td>{{ totals.order_count }} ( ${{ fmt(totals.total_amount) }} )</td>
            <td v-for="country in countries" :key="country">
              <template v-if="totals.by_country[country]">
                <div><strong>{{ $t('columns.qty') }}:</strong> {{ totals.by_country[country].order_count }}</div>
                <div><strong>{{ $t('columns.shipping') }}:</strong> ${{ fmt(totals.by_country[country].shipping) }}</div>
                <div><strong>{{ $t('columns.total') }}:</strong> ${{ fmt(totals.by_country[country].total_amount) }}</div>
              </template>
              <template v-else>-</template>
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import swal from 'sweetalert'
import myDatepicker from 'vue-datepicker'
import statusHelpers from '../../mixins/statusHelpers'

export default {
  mixins: [statusHelpers],
  components: { 'date-picker': myDatepicker },
  data() {
    return {
      loading: false,
      rows: [],
      totals: {},
      countries: [],
      startTime: { time: '' },
      endTime: { time: '' },
      fromOption: this.$_datepickerOption(this.$t('columns.fromDate')),
      toOption: this.$_datepickerOption(this.$t('columns.toDate'))
    }
  },
  mounted() {
    this.initCurrentMonth()
    this.$_fetch_statuses()
  },
  methods: {
    initCurrentMonth() {
      const now = new Date()
      const y = now.getFullYear()
      const m = String(now.getMonth() + 1).padStart(2, '0')
      const lastDay = new Date(y, now.getMonth() + 1, 0).getDate()
      this.startTime.time = `${y}-${m}-01`
      this.endTime.time = `${y}-${m}-${String(lastDay).padStart(2, '0')}`
    },
    fmt(v) {
      return parseFloat(v || 0).toFixed(2)
    },
    // Backed by the admin-configurable Order Status Settings page (statusHelpers mixin).
    statusColor(s) {
      const bg = this.$_status_color(s)
      return { bg, color: this.$_readable_text_color(bg) }
    },
    formatStatus(s) {
      return this.$_status_label(s)
    },
    getData() {
      if (!this.startTime.time || !this.endTime.time) {
        swal(this.$t('common.error'), this.$t('reports.pleaseSelectFromToDate'), 'error')
        return
      }
      this.loading = true
      const token = localStorage.getItem('access_token')
      axios
        .post('api/report/orders', { from_date: this.startTime.time, to_date: this.endTime.time }, {
          headers: { Authorization: 'Bearer ' + token }
        })
        .then(res => {
          this.countries = res.data.countries || []
          this.rows      = res.data.rows
          this.totals    = res.data.totals || {}
        })
        .catch(() => swal(this.$t('common.error'), this.$t('reports.failedToLoadReport'), 'error'))
        .finally(() => { this.loading = false })
    },
    printReport() { window.print() },
    $_datepickerOption(placeholder) {
      return {
        type: 'day',
        week: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
        month: ['January','February','March','April','May','June','July','August','September','October','November','December'],
        format: 'YYYY-MM-DD',
        placeholder,
        inputStyle: { display: 'inline-block', padding: '6px', 'line-height': '22px', 'font-size': '16px', color: '#2d2d2d', width: '100%' },
        color: { header: '#80864D', headerText: '#ffffff' },
        overlayOpacity: 0.5,
        dismissible: true
      }
    }
  }
}
</script>

<style>
@media print {
  @page {
    margin: 8mm;
  }

  body, html {
    margin: 0 !important;
    padding: 0 !important;
  }

  .no-print {
    display: none !important;
  }

  .print-only {
    display: block !important;
  }

  .panel-heading,
  .panel-body {
    padding: 0 !important;
  }

  .table {
    width: 100% !important;
    table-layout: fixed !important;
    border-collapse: collapse !important;
    font-size: 8pt !important;
    word-break: break-word;
  }

  .table th,
  .table td {
    padding: 3px 4px !important;
    font-size: 8pt !important;
    overflow: hidden;
  }

  .col-sub {
    font-size: 6pt !important;
  }
}

.print-only {
  display: none;
}

.table {
  table-layout: fixed;
  width: 100%;
}

.table th,
.table td {
  word-wrap: break-word;
  overflow-wrap: break-word;
}

.col-sub {
  display: block;
  font-weight: 400;
  font-size: 10px;
  opacity: 0.85;
  line-height: 1.2;
  margin-top: 2px;
  white-space: normal;
  word-wrap: break-word;
  overflow-wrap: break-word;
}
</style>



// WEBPACK FOOTER //
// src/components/report/ordersReport.vue